import { request, getInfoLocalStorage, API_URL } from '../../utils/api'
import {
    USER_INFO,
    USER_INFO_LOAD,
    USER_INFO_ERROR,
    USERS_LOAD,
    USERS_SUCCESS,
    USERS_ERROR,
    USER_COMPLETE_ERROR,
    USER_COMPLETE_LOAD,
    USER_COMPLETE_SUCCESS,
    USER_ACCESS_ERROR,
    USER_ACCESS_LOAD,
    USER_ACCESS_SUCCESS
} from '../actionTypes'

export const fetchUserInfo = userid => async dispatch => {
    dispatch(userLoad())
    try {
        const { code, cliente } = await request(`users/${userid}`)
        if (code === 11) {
            dispatch(userInfo(cliente))
        } else {
            dispatch(userInfoError())
        }
    } catch(e) {
        console.log(e)
        dispatch(userInfoError())
    }
}

export const userInfo = user => ({
    type: USER_INFO,
    payload: {
        user
    }
})

export const userLoad = () => ({
    type: USER_INFO_LOAD
})

export const userInfoError = () => ({
    type: USER_INFO_ERROR
})

export const loadUsers = (fundo) => async dispatch => {
    try {
        dispatch(usersLoad())
        const response = await request(`users/fund/${fundo}`)
        if (response.code === 200) {
            dispatch(usersSuccess(response.clientes))
        } else {
            dispatch(usersError())
        }
    } catch(e) {
        console.log(e)
        dispatch(usersError())
    }
}

export const loadUsersSpirit = () => async dispatch => {
    try {
        dispatch(usersLoad())
        const response = await request('users/getSpirit')
        if (response.code === 11) {
            console.log(response)
            dispatch(usersSpiritSuccess(response.clientes))
        } else {
            dispatch(usersError())
        }
    } catch(e) {
        console.log(e)
        dispatch(usersError())
    }
}

export const usersLoad = () => ({
    type: USERS_LOAD
})

export const usersSuccess = users => ({
    type: USERS_SUCCESS,
    payload: {
        users
    }
})

export const usersSpiritSuccess = users => ({
    type: USERS_SUCCESS,
    payload: {
        users
    }
})

export const usersError = () => ({
    type: USERS_ERROR
})

export const completeSignUp = (form, userid) => async dispatch => {
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                try {
                    dispatch(completeSignUpSubmit())
                    const { code, message } = await request('users/complete-signup', 'POST', {
                        senha: values.newPassword,
                        idCliente: userid,
                        nomeMae: values.nomeMae,
                        oldSenha: values.password,
                        rg: values.rg,
                        telefone: values.telefone
                    })
                    if (code === 200) {
                        dispatch(completeSignUpSuccess())
                        dispatch(fetchUserInfo(userid))
                    } else {
                        dispatch(completeSignUpError(message))
                    }
                } catch(e) {
                    dispatch(completeSignUpError())
                }
            }
        })
}

export const completeSignUpSubmit = () => ({
    type: USER_COMPLETE_LOAD
})

export const completeSignUpError = (message = 'Houve um erro ao completar seu cadastro') => ({
    type: USER_COMPLETE_ERROR,
    payload: {
        message
    }
})

export const completeSignUpSuccess = () => ({
    type: USER_COMPLETE_SUCCESS
})

export const requestAssetAccess = userid => async dispatch => {
    dispatch(accessSubmit())
    try {
        const { code, message } = await request(`users/request-asset/${userid}`)
        if (code === 200) {
            dispatch(fetchUserInfo(userid))
            dispatch(accessSuccess(message))
        } else {
            dispatch(accessError(message))
        }
    } catch(e) {
        dispatch(accessError('Houve um erro ao solicitar a permissão.'))
    }
}

export const accessSuccess = message => ({
    type: USER_ACCESS_SUCCESS,
    payload: {
        message
    }
})

export const accessSubmit = () => ({
    type: USER_ACCESS_LOAD
})

export const accessError = message => ({
    type: USER_ACCESS_ERROR,
    payload: {
        message
    }
})